<ng-container *ngIf="seatsToRender.length > 0">
  <ng-container *ngFor="let seat of seatsToRender">
    <div #seatComponent *ngIf="!seat.isPlaceholder" class="seat" [ngClass]="getSeatClass(seat)"
         [adaptivePosition]="false" [isDisabled]="!tooltipEnabled">
      <button (click)="onOccupiedChange()" [disabled]="!isEnabled">
        <!-- <span>{{seat.symbol}}</span> -->
      </button>
    </div>
  </ng-container>
</ng-container>